<!--
 * @Author: ningbo.kang
 * @Date: 2019-12-25 10:41:57
 * @LastEditors: ningbo.kang
 * @LastEditTime: 2021-01-26 16:15:39
 * @Description: 描述
 -->

<template>
  <div :title="tipTitle || text"
    widget-type="input" class="flex-item-input">
    <a-input v-model="text"
      :size="size"
      :data-model="fieldName"
      :type="options.showPassword?'password':'text'"
      :disabled="disabled"
      :placeholder="disabled?'':placeholder"
      :class="clsssName"
      @keyup.enter="handelEnter"
      @blur="handleChange"
      />
    <a-button :loading="transLoading" v-if="options.isGlobal" icon="swap" type="link" @click="translateLangFn">
      {{(langTrans === 'zh-CN' || langTrans === 'zh_CN') ? 'EN' : 'CN' }}
    </a-button>
  </div>
</template>
<script>
import baseMixin from '../../lib/baseMixin';

export default {
  mixins: [baseMixin],
  data() {
    return {
      options: {
        width: '100%',
        defaultValue: '',
        required: false,
        dataType: 'string',
        pattern: '',
        placeholder: '',
        customClass: '',
        disabled: false,
        labelWidth: 100,
        isLabelWidth: false,
        hidden: false,
        dataBind: true,
        showPassword: false,
        remoteFunc: '',
        remoteOption: '',
      },
      lastVal: '',
      tipTitle: '',
      langTrans: this.lang,
      transLoading: false,
    };
  },
  computed: {
    clsssName() {
      if (this.disabled) {
        return `${this.options.customClass} translate`;
      }
      return this.options.customClass;
    },

  },
  methods: {
    initVal(val) {
      if (val) {
        try {
          const parseText = JSON.parse(val);
          if (typeof parseText === 'number') {
            this.text = val;
          } else {
            this.text = this.showGlobalText(parseText);
          }
        } catch (error) {
          this.text = val;
        }
      }
    },
    handelEnter(e) {
      const newVal = e.target.value || this.defaultValue;
      // 将数据抛给上一层，主要是被子表格服务
      this.$emit('change', newVal);

      this.dispatch('wgForm', 'on-enter');
    },
    handleChange(e) {
      const { isGlobal = false } = this.options;
      const newVal = e.target.value || this.defaultValue;
      if (isGlobal) {
        const originVal = this.jsonParseFn() || { 'zh-CN': this.text };
        const targetVal = {
          ...originVal,
        };
        targetVal[this.langTrans] = newVal;
        // 向顶层wgForm注册事件
        if (!this.isNested) {
          const { rowIndex, fieldName: field } = this;
          const value = {
            type: 'input',
            rowIndex,
            field,
            value: targetVal,
          };
          this.dispatch('wgForm', `on-${this.fieldName}-change`, value);
        }
        // 将数据抛给上一层，主要是被子表格服务
        this.$emit('change', JSON.stringify(targetVal));
      } else {
        if (!this.isNested) {
          const { rowIndex, fieldName: field } = this;
          const value = {
            type: 'input',
            rowIndex,
            field,
            value: newVal,
          };
          this.dispatch('wgForm', `on-${this.fieldName}-change`, value);
        }
        // 将数据抛给上一层，主要是被子表格服务
        this.$emit('change', newVal);
      }
    },
    jsonParseFn() {
      try {
        return JSON.parse(this.value);
      } catch (error) {
        return null;
      }
    },
    showGlobalText(value) {
      try {
        const lang = this.langTrans.replace('_', '-');
        return value[lang];
      } catch (error) {
        return value;
      }
    },
    translateLangFn() {
      // 英文不进行英译中
      if (this.langTrans === 'en-US') {
        this.langTrans = 'zh-CN';
        this.initVal(this.value);
        return true;
      }
      // 中英文皆有 但是中文内容更新

      // 当中英文皆有值时不翻译
      if (this.jsonParseFn() && this.jsonParseFn()['en-US']) {
        this.langTrans = 'en-US';
        this.initVal(this.value);
        return true;
      }
      this.transLoading = true;
      const params = {
        sourceLanguage: 'zh',
        text: this.text,
        targetLanguage: 'en',
      };
      this.remote.translateLanguage(params).then((res) => {
        this.langTrans = this.langTrans === 'en-US' ? 'zh-CN' : 'en-US';
        const { content } = res;
        this.handleChange({ target: { value: content } });
        this.initVal(this.value);
      }).finally(() => {
        this.transLoading = false;
      });
    },
  },
};
</script>
